import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import { CompanyInterface } from "../../Entity/Entities/Company/CompanyInterface";
import Constants from "../../Action/Constants";

class AgencyProfileWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const agency: CompanyInterface = this.component.props.app?.companies?.find((company: CompanyInterface) => company?.isAgency);
    const settings = this.component.props?.app?.settings?.agency;
    const usingBeta = this.component.props.app?.settings?.user?.beta;

    const settingsUpdateAgencyCategory = this.component.props.app.settingsUpdateAgencyCategory;

    if (settingsUpdateAgencyCategory) {
      this.component.props.dispatch({
        type: Constants.PAGE_SETTINGS_UPDATE_AGENCY_CATEGORY,
        payload: {
          category: ""
        }
      });
    }

    this.component.setState({
      settings: settings,
      name: agency.name,
      shortName: agency.shortName,
      email: agency.email,
      phone: agency.phone,
      address: agency.address,
      defaultLocale: settings.defaultLocale.iso,
      defaultLanguage: settings.defaultLanguage.iso,
      defaultCalculation: settings.defaultCalculation,
      beta: usingBeta,
      financialStartDate: settings.financialStartDate,
      note: agency.note,
      mainBankAccountId: agency.agencyBankAccountId,
      mainBankAccountName: agency.agencyBankAccountName,
      attachments: agency.attachments,
      notificationPeriod: settings.notificationPeriod,
      isBusy: settings.isBusy,
      bic: agency.bic,
      companyRegistry: agency.companyRegistry,
      vat: agency.vat,
      website: agency.website,
      vatPercentage: settings.vatPercentage,
      savingsAccount: agency.savingsAccount,
      generalContactId: agency.generalContactId,
      isActivateInvoiceNumber: settings.isActivateInvoiceNumber,
      reviewOwnerStatements: settings.reviewOwnerStatements,
      statementEmailTextEn: settings.statementEmailTextEn,
      statementEmailTextNl: settings.statementEmailTextNl,
      adjustRentEmailTextEN: settings.adjustRentEmailTextEN,
      adjustRentEmailTextNL: settings.adjustRentEmailTextNL,
      expanded: this.component.props?.agencySettings ? "agencyProfile" : settingsUpdateAgencyCategory ? settingsUpdateAgencyCategory : null,
      sendCopyToEmails: settings.sendCopyToEmails,
      sendCopyToSubject: settings.sendCopyToSubject,
      useAgencyAsSenderForAutoEmails: settings.useAgencyAsSenderForAutoEmails,
      invoiceEmailAddress: agency.invoiceEmailAddress,
      invoiceEmailSubject: agency.invoiceEmailSubject,
    });
  }
}

export default new AgencyProfileWillMount();
